/**
 * RDS-3.2 Manheim light badge, shared by the Client View VIN table and VIN pop-out.
 * GREEN / YELLOW / RED come from the auction's light system; NOT_AS_IS is a digital
 * listing that is not as-is but announces no light (deliberately not shown as green).
 */
import React from 'react';
import { LIGHT_SOURCES, LIGHTS } from './lightLabels';
import './LightBadge.css';

export const LightBadge: React.FC<{
  light?: string | null;
  source?: string | null;
  titleAbsent?: number | boolean | null;
}> = ({ light, source, titleAbsent }) => {
  const key = (light || '').trim().toUpperCase();
  const info = LIGHTS[key];
  const sourceText = source ? LIGHT_SOURCES[source.trim().toUpperCase()] : undefined;
  const title = [
    info ? `${info.label}: ${info.meaning}` : 'Light unknown',
    sourceText ? `Light ${sourceText}.` : null,
    titleAbsent ? 'Title absent: the title is not present at sale (up to 30 days to deliver).' : null,
  ].filter(Boolean).join(' ');
  return (
    <span className="light-badge-wrap" title={title}>
      {info ? (
        <span className={`light-badge light-badge--${info.tone}`}>
          <span className="light-badge-dot" aria-hidden="true" />
          {info.label}
          {source?.trim().toUpperCase() === 'PRIOR_LANE' && <span className="light-badge-prior"> (prior)</span>}
        </span>
      ) : (
        <span className="light-badge-none">–</span>
      )}
      {titleAbsent ? <span className="light-badge-title">Title absent</span> : null}
    </span>
  );
};
